import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

import { connect } from 'react-redux';
import * as ContractSearch from './Saga/ContractSearch';

// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';

// import DatePicker from "react-datepicker";
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  get_rent_contracts: any,
  change_search_name: any,
  change_search_contract_date_start: any,
  change_search_contract_date_end: any,
  search_contract_date_start: any,
  search_contract_date_end: any,
  change_search_tatemono_name: any,
  bind_kyousai_contract_cancel: any,
  bind_disabled: any,
  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string
}



interface State {

}


class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.props.change_search_name("")
    // this.props.change_search_contract_date_start(new Date())
    this.props.change_search_contract_date_end(null)
    this.change_search_name = this.change_search_name.bind(this);

    this.handleContractionDateChange = this.handleContractionDateChange.bind(this);
    this.handleContractionDateChangeEnd = this.handleContractionDateChangeEnd.bind(this);

    this.change_search_tatemono_name = this.change_search_tatemono_name.bind(this);

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }
  change_search_name(e: any) {

    this.props.change_search_name(e.target.value)
  }

  change_search_tatemono_name(e: any) {
    this.props.change_search_tatemono_name(e.target.value)
  }
  handleContractionDateChange(e: any) {
    this.props.change_search_contract_date_start(e)

  }
  handleContractionDateChangeEnd(e: any) {

    this.props.change_search_contract_date_end(e)
  }

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div>

        <table>

          <tbody>

            <tr >
              <th>お客様名：</th>
              <td >
                <TextField
                  name="name"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_name}
                  className="form-control"
                />

              </td>
              <th>物件名：</th>
              <td >
                <TextField
                  name="tatemonoName"
                  //   component="input"
                  type="text"
                  //placeholder=""
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_rent_contracts()
                    }
                  }}
                  onChange={this.change_search_tatemono_name}
                  className="form-control"
                />

              </td>
              <td>
                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={this.props.get_rent_contracts}
                  className="btn btn-primary float-right"
                >検索</button>
              </td>
            </tr>
            <tr >
              <th>契約日：</th>
              <td colSpan={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="contractDataStart"
                    //    onChange={this.handleContractionDateChangeStart}
                    value={this.props.search_contract_date_start}
                    //    value={this.props.estimateData.contractDate}
                    onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
                  ～
                  <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="契約日"
                    style={{ marginLeft: "20px" }}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="contractDataEnd"
                    value={this.props.search_contract_date_end}
                    // //  value={this.props.estimateData.applicationDate}
                    onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>


                <button
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={this.props.bind_kyousai_contract_cancel}
                  disabled={this.props.bind_disabled}
                  className="btn btn-warning float-right"
                >結付解除</button>

              </td>

            </tr >
          </tbody>
        </table>








      </div>
    );
  }
}




// const mapStateToProps = (state:any) => {
//     return {

//         responseid: state.customersReducer.responseid,
//         responsedetail: state.customersReducer.responsedetail,
//         customerNewDisp: state.customersReducer.customerNewDisp,
//         customerdetail0: state.customersReducer.customerdetail0

//     }
// }
// function mapDispatchToProps(dispatch:any) {
//     return {

//         // responseUpdate(state:any) {
//         //     dispatch(Responses.responseUpdate(state))
//         // },
//         // change_customerloding1(state:number) {
//         //     dispatch(Customers.change_customerloding1(state))
//         // },
//         // change_customerloding2(state:number) {
//         //     dispatch(Customers.change_customerloding2(state))
//         // },
//         // customerNewDispSet(state:number) {
//         //     dispatch(Customers.customerNewDispSet(state))
//         // },
//         // change_customeredit0(state:number) {
//         //     dispatch(Customers.change_customeredit0(state))
//         // },
//        get_rent_contract_accounting(state:any) {
//             dispatch(Monies.get_rent_contract_accounting(state))
//         },

//     };
// }
// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);

const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    search_contract_date_start: state.contractsearchReducer.search_contract_date_start,
    search_contract_date_end: state.contractsearchReducer.search_contract_date_end,
    bind_disabled: state.contractsearchReducer.bind_disabled,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    get_rent_contracts(state: any) {
      dispatch(ContractSearch.get_rent_contracts(state))
    },
    change_search_name(state: any) {
      dispatch(ContractSearch.change_search_name(state))
    },
    change_search_contract_date_start(state: any) {
      dispatch(ContractSearch.change_search_contract_date_start(state))
    },
    change_search_contract_date_end(state: any) {
      dispatch(ContractSearch.change_search_contract_date_end(state))
    },
    change_search_tatemono_name(state: any) {
      dispatch(ContractSearch.change_search_tatemono_name(state))
    },
    bind_kyousai_contract_cancel(state: any) {
      dispatch(ContractSearch.bind_kyousai_contract_cancel(state))
    },
    //   get_banks(state:any) {
    //     dispatch(Kyousai.get_banks(state))
    // },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

